export default [
  {
    path: '/',
    name: 'cdy',
    meta: {
      title: '草都云草牧业全国大数据平台',
    },
    component: () => import(/* webpackChunkName: "cdyLayout" */ '@/views/cdy/layout/layout.vue'),
    children: [
      {
        path: '/',
        name: 'cdyIndex',
        meta: {
          title: '草都云草牧业全国大数据平台',
        },
        component: () => import(/* webpackChunkName: "cdyIndex" */ '@/views/cdy/index/index.vue'),
      },
      {
        path: '/district',
        name: 'cdyDistrict',
        meta: {
          title: '草都云草牧业地区大数据平台',
        },
        component: () => import(/* webpackChunkName: "cdyDistrict" */ '@/views/cdy/district/district.vue'),
      },
      {
        path: '/grass',
        name: 'cdyGrass',
        meta: {
          title: '草都云草牧业草业大数据平台',
        },
        component: () => import(/* webpackChunkName: "cdyDistrict" */ '@/views/cdy/grass/index.vue'),
      },
      {
        path: '/livestock',
        name: 'cdyLivestock',
        meta: {
          title: '草都云牛马羊大数据平台',
        },
        component: () => import(/* webpackChunkName: "cdyDistrict" */ '@/views/cdy/livestock/index.vue'),
      },
      {
        path: '/zbIndex',
        name: 'cdyZbIndex',
        meta: {
          title: '草都云畜牧业张北大数据平台',
        },
        component: () => import('@/views/cdy/zbIndex/index.vue'),
      },
      {
        path: '/blzqIndex',
        name: 'blzqIndex',
        meta: {
          title: '草都云畜牧业巴林左旗大数据平台',
        },
        component: () => import('@/views/cdy/blzqIndex/index.vue'),
      },
    ],
  },
];
